export default "__VITE_ASSET__B4M4ZQZ2__"